import type {
  TriggerCriteria,
  PriceTriggerRequirementType,
} from '@vertex-protocol/client';
import type { BigNumberish } from '@vertex-protocol/utils';

/**
 * Safely extracts the trigger price from a TriggerCriteria discriminated union.
 * Returns undefined for time-type triggers (which have no trigger price).
 */
export function getTriggerCriteriaPrice(
  triggerCriteria: TriggerCriteria,
): BigNumberish | undefined {
  if (triggerCriteria.type === 'price') {
    return triggerCriteria.criteria.triggerPrice;
  }
  return undefined;
}

/**
 * Safely extracts the price trigger requirement type (e.g. 'oracle_price_above')
 * from a TriggerCriteria discriminated union.
 * Returns undefined for time-type triggers.
 */
export function getPriceTriggerRequirementType(
  triggerCriteria: TriggerCriteria,
): PriceTriggerRequirementType | undefined {
  if (triggerCriteria.type === 'price') {
    return triggerCriteria.criteria.type;
  }
  return undefined;
}
